import React from "react";
import PropTypes from "prop-types";
import Loader from "../Components/Loading";

const CannabisShowCaseLoading = ({ loading }) => {
    return (
        <div className="py-5">
            <Loader isLoading={loading} text="Please wait..." />
        </div>
    );
};

CannabisShowCaseLoading.defaultProps = {
    loading: true
};

CannabisShowCaseLoading.propTypes = {
    loading: PropTypes.bool
};

export default CannabisShowCaseLoading;
